<template>
  <div>
    <head-intro @go="toStore($event)" />

    <div id="share">
      <video
        id="bgVideo"
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        autoplay
        loop
        muted
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline
      >
        <source src="../assets/video/bg.mp4" type="video/mp4" />
      </video>

      <div class="center" style="margin-top:128vw">
        <img src="../assets/img/new/txt_1.png" style="width: 95%" />
      </div>
      <div class="center">
        <img src="../assets/img/new/txt_2.png" style="width: 55%" />
      </div>
      <div class="center">
        <img
          src="../assets/img/new/btn_2.png"
          style="width: 75%; margin-top: 1%"
          @click="toStore('middle')"
        />
      </div>

      <more-slots />
      <rich-events />
      <fan-pages />
      <div class="center" style="margin-top: 10vw; cursor:pointer">
        <div style="height: 25vw; width: 75vw" @click="toStore('bottom')" />
      </div>
    </div>
  </div>
</template>

<script>
import HeadIntro from "./head-intro";
import axios from "axios";
import moment from "moment";
import MoreSlots from "./more-slots";
import RichEvents from "./rich-events";
import FanPages from "./fan-pages";
import Util from "./util";

export default {
  components: {
    HeadIntro,
    MoreSlots,
    RichEvents,
    FanPages,
  },
  data() {
    return {
      platform: "",
      share_user_id: "",
      login_user_id: "",
      is_first_scroll: true,
    };
  },
  mounted() {
    const shareBody = document.getElementById("share");
    const bgvideo = document.getElementById("bgVideo");
    shareBody.addEventListener("click", () => {
      bgvideo.play();
    });
    shareBody.addEventListener("touchstart", () => {
      bgvideo.play();
    });
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    init() {
      // 判断设备类型
      const user_device = navigator.userAgent;
      const isAndroid =
        user_device.indexOf("Android") > -1 || user_device.indexOf("Adr") > -1;
      const isiOS = !!user_device.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        this.platform = "AND";
      }
      if (isiOS) {
        this.platform = "IOS";
      }

      // 获取分享人id
      const url = window.location.href;
      const index = url.indexOf("?");
      const params = url.slice(index + 1).split("&");
      const query = {};
      params.forEach((item) => {
        const tempArr = item.split("=");
        query[tempArr[0]] = tempArr[1];
      });
      this.share_user_id = query.user_id || "-";

      const timeStamp = new Date().valueOf();
      // 授予登录人id
      if (window.localStorage.getItem("login_user_id")) {
        this.login_user_id = window.localStorage.getItem("login_user_id");
      } else {
        this.login_user_id =
          this.share_user_id +
          "-" +
          timeStamp +
          "-" +
          Math.round(Math.random() * 1000);
        window.localStorage.setItem("login_user_id", this.login_user_id);
      }

      axios({
        url: `/phoenix/mounted`,
        method: "POST",
        data: {
          login_user_id: this.login_user_id,
          share_user_id: this.share_user_id,
          device_type: this.platform,
          date: moment()
            .utc()
            .format("YYYY-MM-DD HH:ss:mm"),
          timestamp: new Date().valueOf(),
          url: url,
          language: navigator.language,
          user_device: navigator.userAgent,
          performance_navigation_type: window.performance.navigation.type,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        scrollTop >= document.documentElement.clientHeight &&
        this.is_first_scroll
      ) {
        this.is_first_scroll = false;
        axios({
          url: `/phoenix/scroll`,
          method: "POST",
          data: {
            login_user_id: this.login_user_id,
            share_user_id: this.share_user_id,
            device_type: this.platform,
            date: moment()
              .utc()
              .format("YYYY-MM-DD HH:ss:mm"),
            timestamp: new Date().valueOf(),
            url: window.location.href,
            language: navigator.language,
            user_device: navigator.userAgent,
            performance_navigation_type: window.performance.navigation.type,
          },
          headers: {
            "Content-Type": "application/json",
          },
        });
      }
    },
    toStore(type) {
      axios({
        url: `/phoenix/click`,
        method: "POST",
        data: {
          login_user_id: this.login_user_id,
          share_user_id: this.share_user_id,
          device_type: this.platform,
          date: moment()
            .utc()
            .format("YYYY-MM-DD HH:ss:mm"),
          timestamp: new Date().valueOf(),
          url: window.location.href,
          to_url:
            "https://haqy.adj.st/gift?parameter=daily_ins_a42caef4b36b08079f043cccc7ce0116&adjust_t=bxly1c6_kt83pbb&adjust_deeplink_js=1&adj_deep_link=com.cashfrenzy.slots%3A%2F%2Fgift%3Fparameter%3Ddaily_ins_a42caef4b36b08079f043cccc7ce0116",
          button_type: type,
          language: navigator.language,
          user_device: navigator.userAgent,
          performance_navigation_type: window.performance.navigation.type,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(() => {
          window.location.href =
            "https://haqy.adj.st/gift?parameter=daily_ins_a42caef4b36b08079f043cccc7ce0116&adjust_t=bxly1c6_kt83pbb&adjust_deeplink_js=1&adj_deep_link=com.cashfrenzy.slots%3A%2F%2Fgift%3Fparameter%3Ddaily_ins_a42caef4b36b08079f043cccc7ce0116";
        })
        .catch(() => {
          window.location.href =
            "https://haqy.adj.st/gift?parameter=daily_ins_a42caef4b36b08079f043cccc7ce0116&adjust_t=bxly1c6_kt83pbb&adjust_deeplink_js=1&adj_deep_link=com.cashfrenzy.slots%3A%2F%2Fgift%3Fparameter%3Ddaily_ins_a42caef4b36b08079f043cccc7ce0116";
        });
    },
  },
};
</script>
<style lang="less">
#share {
  position: absolute;
  width: 100vw;

  #bgVideo {
    position: absolute;
    left: 0;
    top: 0;
    height: auto;
    width: 100%;
    z-index: -1;
    margin-bottom: -10px;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .download {
    position: absolute;
    bottom: 47.3vw;
    height: 22vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share.vue